import React, { useRef } from 'react'
/** @jsxImportSource @emotion/react */
import { css} from '@emotion/react'
import { Space,Table ,DatePicker,Pagination, Select, Input, Button} from 'antd';
import { useState } from 'react';
import { useEffect } from 'react';
import dayjs from 'dayjs';
import {DollarOutlined ,BookOutlined, PlusCircleOutlined } from '@ant-design/icons';
import TollOutlinedIcon from '@mui/icons-material/TollOutlined';

import axios from '../apiClient';
import Alert from '../alert';
import moment from 'moment/moment';
import { useLocation, useNavigate } from 'react-router-dom';
import { Tabs } from '@mui/material';

const {RangePicker} = DatePicker;

export default function Slips() {
  const navigate = useNavigate();
  const location = useLocation();
  const [page,setPage] = useState(1);
  const [slips,setSlips] = useState([]);
  const [totalSlips, setTotalSlips] = useState();
  const [loading,setLoading] = useState(false)
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const [searchName,setSearchName] = useState('');
  const [slipId,setSlipId] = useState('');
  const [betStatus,setBetStatus] = useState('')
  const [oddType,setOddType] = useState('')
  const [resultType,setResultType] = useState('')
  const [completeType,setCompleteType] = useState('')
  const [date,setDate] = useState({})
  const didMount = useRef(false);
  const [reports, setReports] = useState({})

  const completeTypeOptions = [{value: "",label: "completed/uncompleted"},{value: true,label: "completed"},{value: false,label: "uncompleted"}]
  const resultTypeOptions = [{value: "",label: "win/loss/pending"},{value: "win",label: "win"},{value: "loss",label: "loss"},{value: "pending",label: "pending"}]
  const oddTypeOptions = [
    {value: "",label: "All"},
    {value: "single",label: "Body"},
    {value: "single-1H",label: "Body(1H)"},
    {value: "single-2H",label: "Body(2H)"},
    {value: "single-FT",label: "Body(FT)"},
    {value: "mix_parlay",label: "Parlay"},
    {value: "mix_parlay-1H",label: "Parlay(1H)"},
    {value: "mix_parlay-2H",label: "Parlay(2H)"},
    {value: "mix_parlay-FT",label: "Parlay(FT)"},
  ]
  const betStatusOptions = [{value: "",label: "accepted/rejected/deleted"},{value: "accepted",label: "accepted"},{value: "rejected",label: "rejected"},{value: "deleted",label: "deleted"}]


  async function fetchData() {
    setLoading(true)
    let res = await axios.get(`/report/getSlipByMasterName?version=1.1&masterName=${searchName}&slipId=${slipId}&betStatus=${betStatus}&oddType=${oddType}&startDate=${date.startDate} 08:00:00&endDate=${date.endDate} 08:00:00&current=${page}&pageSize=10&status=${resultType}&completed=${completeType}`)

    if (res.code != 200) {
        if(res.code == 404){
            setLoading(false)
            setSlips([])
            return
        }
        setErrorMsg({ code: res.code, msg: res.message })
        setOpenAlert(true)
        setLoading(false)
        return
    }
    setSlips(res.data.slip)
    setReports(res?.data?.report)
    setTotalSlips(res.data.pagination.total)
    setLoading(false)
  }


  const handleCloseAlert = () => setOpenAlert(false)
  
  const handlePageChange = (page) => setPage(page)
  
  const handleSearchUsername = ({currentTarget}) => {
    setSearchName(currentTarget.value);
    setPage(1);
  }

  const handleSearchSlipId = ({currentTarget}) => {
    setSlipId(currentTarget.value.replace(/\s/g,''));
    setPage(1);
  }
  
  const handleDateChange = async (v,dateString) => {
    setDate({startDate: dateString[0],endDate: dateString[1]});
    setPage(1);
  };

  const handleRowClick = (rowData) =>{
    navigate('/bets/betDetails',{state: {rowData, date, searchName, slipId, betStatus, oddType, page, includeRejectedUI: betStatus != "rejected" ? true : false,resultType,completeType}})
  }
  
  useEffect(()=> {
    if(!didMount.current){
      didMount.current = true;
      if(location?.state){
        const {date, searchName, slipId, betStatus, oddType, page,resultType,completeType} = location.state;
        setPage(page);
        setSearchName(searchName);
        setSlipId(slipId);
        setDate(date);
        setBetStatus(betStatus);
        setOddType(oddType);
        setResultType(resultType)
        setCompleteType(completeType)
      }else{
        const yesterday = moment().subtract(1,'days').format('YYYY-MM-DD');
        const tmr = moment().add(1,'days').format('YYYY-MM-DD');
        setDate({startDate: yesterday,endDate: tmr});
      }
    }else{
      fetchData()
    }
  },[searchName, date, page, slipId, betStatus, oddType,resultType,completeType])

  const columns = [
      {
        title: 'Username',
        //dataIndex: 'masterName',
        render: ({member}) =>  member?.username,
        key: 'id',
      },
      {
        title: 'Master',
        dataIndex: 'masterName',
        key: 'id',
      },
      {
        title: 'Slip Id',
        dataIndex: 'shortId',
        key: 'id',
      },
      {
        title: 'Bet Amount',
        dataIndex: 'betAmount',
        key: 'id',
      },
      {
        title: 'Win Amount',
        dataIndex: 'winnedAmount',
        key: 'id',
      },
      
      // {
      //   title: 'Match',
      //   render: ({betType,bet}) => betType == "mix_parlay" ? "-" :  bet[0].match.homeTeam.name_en + "-" +  bet[0].match.awayTeam.name_en,
      //   key: 'id',
      // },
      // {
      //   title: 'Odd',
      //   key: 'id',
      //   render: ({betType,bet}) => betType == "mix_parlay" ? "-" : bet[0].betData.converted,
      // },
      {
        title: 'Odd Type',
        key: 'id',
        dataIndex: 'betType',
      },
      {
        title: 'Bet Status',
        key: 'id',
        dataIndex: 'betStatus',
      },
      {
        title: 'Result Status',
        key: 'id',
        dataIndex: 'status',
      },
      {
        title: 'Completed',
        key: 'id',
        dataIndex: 'completed',
      },
      {
        title: 'Bet Date',
        dataIndex: 'betDate',
        key: 'id',
        render: (date) => moment(date).format("DD-MM-YYYY h:mm A")
      },
      {
        title: 'Action',
        fixed: 'right',
        render: () => {
          const color = `#655DBB`
          return (
          <Space size="middle">
              <Button css={css`color: black;border-color: ${color};:hover{border-color: ${color};}`} color='success' variant="outlined" >
                  Detail
              </Button>
          </Space>
        )},
      },

  ];
  const handleBetStatusChange = (value) => {
    setBetStatus(value);
    setPage(1);
  };
  const handleResultTypeChange = (value) => {
    setResultType(value);
    setPage(1);
  };
  const handleCompleteTypeChange = (value) => {
    setCompleteType(value);
    setPage(1);
  };

  const handleOddTypeChange = (value) => {
    setOddType(value);
    setPage(1);
  };

    return (
      <div>
    <div>
       <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
       <div  style={{display: 'flex', overflowX: "scroll",overflow: 'hidden'}}>
        <Tabs
            indicatorColor="primary"
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
            aria-label="scrollable force tabs example"
          >
          <div style={{display: 'flex',alignItems: "center",padding: "0 3rem 2rem 1rem"}}>
            <DollarOutlined    style={{fontSize: "2.5rem",marginRight: "1rem",color: "#399bac"}}/>
             <div>
               <h3 style={{marginBottom: "1rem",fontWeight: "normal"}}>Win/Loss</h3>
               <h3 style={{fontWeight: "normal",color: Number(reports?.totalWinLoss || 0) >= 0 ? "#000dff" : "red" }}>{Number(reports?.totalWinLoss || 0) > 0 ? "+ " : ""}{Number(reports?.totalWinLoss || 0).toLocaleString()}</h3>
             </div>
          </div>
          <div style={{display: 'flex',alignItems: "center",padding: "0 3rem 2rem 1rem"}}>
            <BookOutlined   style={{fontSize: "2.5rem",marginRight: "1rem",color: "#77ba4f"}}/>
             <div>
               <h3 style={{marginBottom: "1rem",fontWeight: "normal"}}>Total Slips</h3>
               <h3 style={{fontWeight: "normal",color: "black"}}>{Number(reports?.totalSlip || 0).toLocaleString()}</h3>
             </div>
          </div>
          <div style={{display: 'flex',alignItems: "center",padding: "0 3rem 2rem 1rem"}}>
            <BookOutlined   style={{fontSize: "2.5rem",marginRight: "1rem",color: "indigo"}}/>
             <div>
               <h3 style={{marginBottom: "1rem",fontWeight: "normal"}}>Mix Parlay Slips(2)</h3>
               <h3 style={{fontWeight: "normal",color: "black"}}>{Number(reports?.twoParlayBettedAmount || 0).toLocaleString()}</h3>
             </div>
          </div>
          <div style={{display: 'flex',alignItems: "center",padding: "0 3rem 2rem 1rem"}}>
            <BookOutlined   style={{fontSize: "2.5rem",marginRight: "1rem",color: "purple"}}/>
             <div>
               <h3 style={{marginBottom: "1rem",fontWeight: "normal"}}>Mix Parlay Slips{`(>2)`}</h3>
               <h3 style={{fontWeight: "normal",color: "black"}}>{Number(reports?.twoOverParlayBettedAmount || 0).toLocaleString()}</h3>
             </div>
          </div>
          <div style={{display: 'flex',alignItems: "center",padding: "0 3rem 2rem 1rem"}}>
            <BookOutlined   style={{fontSize: "2.5rem",marginRight: "1rem",color: "#063245"}}/>
             <div>
               <h3 style={{marginBottom: "1rem",fontWeight: "normal"}}>Body Slips</h3>
               <h3 style={{fontWeight: "normal",color: "black"}}>{Number(reports?.singleBettedAmount || 0).toLocaleString()}</h3>
             </div>
          </div>
          <div style={{display: 'flex',alignItems: "center",padding: "0 3rem 2rem 1rem"}}>
            <PlusCircleOutlined   style={{fontSize: "2.5rem",marginRight: "1rem",color: "#5C6CC7"}}/>
             <div>
               <h3 style={{marginBottom: "1rem",fontWeight: "normal"}}>Commission</h3>
               <h3 style={{fontWeight: "normal",color: "black"}}>{Number(reports?.totalCommissionAmount || 0).toLocaleString()}</h3>
             </div>
          </div>
          
          <div>
          </div>
        </Tabs>
       </div>
       <div style={{display: 'flex'}}>
         <Space direction="vertical" size={11}      style={{width: "30%"}}>
          <RangePicker
            value={date.startDate ? [dayjs(date.startDate, 'YYYY-MM-DD'), dayjs(date.endDate, 'YYYY-MM-DD')] : ''}
            onChange={(v,dateString)=> handleDateChange(v,dateString)}/>
          </Space>
          <Input placeholder={`Master...`}  style={{width: "20%",marginLeft: "0.5rem"}} onChange={handleSearchUsername} value={searchName}/>
          <Select
            value={betStatus}
            style={{width: "15%",marginLeft: "0.5rem"}}
            onChange={handleBetStatusChange}
            // filterOption={(inputValue, option)=> {return option.label.toLowerCase().includes(inputValue.toLowerCase());}}
            showSearch
            options={betStatusOptions}
          />
           <Select
            value={oddType}
            style={{width: "15%",marginLeft: "0.5rem"}}
            onChange={handleOddTypeChange}
            // filterOption={(inputValue, option)=> {return option.label.toLowerCase().includes(inputValue.toLowerCase());}}
            showSearch
            options={oddTypeOptions}
          />
           <Select
            value={resultType}
            style={{width: "15%",marginLeft: "0.5rem"}}
            onChange={handleResultTypeChange}
            // filterOption={(inputValue, option)=> {return option.label.toLowerCase().includes(inputValue.toLowerCase());}}
            showSearch
            options={resultTypeOptions}
          />
           <Select
            value={completeType}
            style={{width: "15%",marginLeft: "0.5rem"}}
            onChange={handleCompleteTypeChange}
            // filterOption={(inputValue, option)=> {return option.label.toLowerCase().includes(inputValue.toLowerCase());}}
            showSearch
            options={completeTypeOptions}
          />
          <Input placeholder={`Slip Id...`}  style={{width: "15%",marginLeft: "0.5rem"}} onChange={handleSearchSlipId} value={slipId}/>
       </div>
      <Table onRow={(rowData)=>{
          return(
            {onClick: () =>handleRowClick(rowData)}
          )
       }}
      loading={loading} scroll={{ x: 'max-content' }} css={css`padding-top: 2rem;`} pagination={false} columns={columns} dataSource={slips} />
      <Pagination className='pagination' css={css`display: flex;justify-content: end;padding-top: 1rem;`} current={page} total={totalSlips} pageSize={10} showSizeChanger={false} onChange={(page) => handlePageChange(page)} />
    </div>
  </div>
  )
}

